import { useState } from 'react';
import { Box, Container, Tab, Tabs } from '@mui/material';
import Page from '../components/Page';

import DealerBind from './DealerBind';
import DealerCreate from './DealerCreate';
import DealerStaffList from './DealerList';
import DealerTerminate from './DealerTerminate';

function TabPanel({ value, index, keepMounted = false, children }) {
  const isActive = value === index;
  if (!keepMounted && !isActive) return null;

  return (
    <Box role="tabpanel" hidden={!isActive} sx={{ pt: 2 }}>
      {children}
    </Box>
  );
}

const TABS = [
  { label: 'Create Dealer', Component: DealerCreate },
  { label: 'Terminate Dealer', Component: DealerTerminate },
  { label: 'User Management', Component: DealerStaffList },
  { label: 'Bind Phone', Component: DealerBind },
];

export default function DealersPage() {
  const [tab, setTab] = useState(0);
  const [activated, setActivated] = useState(() => new Set([0]));

  const handleTabChange = (_, newValue) => {
    setTab(newValue);
    setActivated((prev) => {
      if (prev.has(newValue)) return prev;
      const next = new Set(prev);
      next.add(newValue);
      return next;
    });
  };

  return (
    <Page>
      <Container disableGutters>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Dealer management tabs"
        >
          {TABS.map(({ label }) => (
            <Tab key={label} label={label} />
          ))}
        </Tabs>

        {TABS.map(({ Component }, index) => {
          if (!activated.has(index)) return null;

          return (
            <TabPanel key={index} value={tab} index={index} keepMounted>
              <Component />
            </TabPanel>
          );
        })}
      </Container>
    </Page>
  );
}
